import { ComplaintDialogContext } from "./DialogContext";
import Modal from "../../../../components/portal/Modal";
// Attached all children
import "./Header"
import "./Deatails"
import "./Content"
import "./Remark"
import "./Pictures"
import "./Footer"


export function ComplaintModalLayout({ children, value}) {
  return (
    <ComplaintDialogContext.Provider value={value }>
      <Modal
        onClose={value.successView ? undefined : value.closeDialog}
        modalWidth="view-dialog-content"
        closeIcon={!value.successView}
      >
        {children}
      </Modal>
    </ComplaintDialogContext.Provider>
  );
}
